(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMarquee(marqueeEl) {
      if (!marqueeEl || marqueeEl.dataset.marqueeReady) return;
      marqueeEl.dataset.marqueeReady = '1';
      const track = marqueeEl.querySelector('[data-marquee-track]');
      if (!track) return;
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-marquee-track');
      marqueeEl.appendChild(clone);
    }

    document.querySelectorAll('.sk-brands__marquee').forEach(initMarquee);

    document.addEventListener('shopify:section:load', function (e) {
      const marquee = e.target.querySelector('.sk-brands__marquee');
      if (marquee) initMarquee(marquee);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  // Hero video: controls on desktop, hidden on mobile until the video is tapped.
  (function () {
    var videos = document.querySelectorAll('.sk-hero__dashboard-video');
    if (!videos.length) return;

    var desktop = window.matchMedia('(min-width: 961px)');

    function sync() {
      videos.forEach(function (video) {
        video.controls = desktop.matches;
      });
    }

    sync();

    if (desktop.addEventListener) {
      desktop.addEventListener('change', sync);
    } else if (desktop.addListener) {
      desktop.addListener(sync);
    }

    videos.forEach(function (video) {
      video.addEventListener('click', function () {
        if (!desktop.matches) {
          video.controls = true;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-call-form"] && !Shopify.designMode) return;
  try {
    
  class ProductionCallFormSteps {
    constructor(root) {
      this.root = root;
      this.currentStep = Number(root.dataset.currentStep) || 1;
      this.stepContents = [...root.querySelectorAll('[data-step-content]')];
      this.triggers = [...root.querySelectorAll('[data-step-trigger]')];
      this.next = root.querySelector('[data-step-next]');
      this.prev = root.querySelector('[data-step-prev]');
      this.submit = root.querySelector('[data-step-submit]');

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.goTo(Number(trigger.dataset.stepTrigger), true));
      });

      if (this.next) {
        this.next.addEventListener('click', () => this.goTo(this.currentStep + 1, true));
      }

      if (this.prev) {
        this.prev.addEventListener('click', () => this.goTo(this.currentStep - 1, false));
      }

      this.root.productionCallFormSteps = this;
      this.update();
    }

    activeStepEl() {
      return this.root.querySelector(`[data-step-content="${this.currentStep}"]`);
    }

    validateCurrentStep() {
      const step = this.activeStepEl();
      if (!step) return true;
      return [...step.querySelectorAll('input, select, textarea')].every((input) => {
        if (typeof input.reportValidity === 'function') {
          return input.reportValidity();
        }
        return true;
      });
    }

    goTo(step, shouldValidate, allowSkip = false) {
      if (step < 1 || step > 3 || step === this.currentStep) return;
      if (!allowSkip && step > this.currentStep + 1) step = this.currentStep + 1;
      if (shouldValidate && step > this.currentStep && !this.validateCurrentStep()) return;

      this.currentStep = step;
      this.update();
    }

    update() {
      this.root.dataset.currentStep = String(this.currentStep);

      this.stepContents.forEach((step) => {
        step.hidden = Number(step.dataset.stepContent) !== this.currentStep;
      });

      this.triggers.forEach((trigger) => {
        const isActive = Number(trigger.dataset.stepTrigger) === this.currentStep;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (this.prev) this.prev.hidden = this.currentStep === 1;
      if (this.next) this.next.hidden = this.currentStep === 3;
      if (this.submit) this.submit.hidden = this.currentStep !== 3;
    }
  }

  const normalizeValue = (value) => {
    if (typeof value !== 'string') return '';
    return value.trim();
  };

  const splitName = (fullName) => {
    const parts = normalizeValue(fullName).split(/\s+/).filter(Boolean);
    if (!parts.length) return { firstName: '', lastName: '' };
    if (parts.length === 1) return { firstName: parts[0], lastName: '' };
    return {
      firstName: parts[0],
      lastName: parts.slice(1).join(' '),
    };
  };

  const getQuantityPosition = (form) => {
    const select = form.querySelector('[name="contact[estimated-quantity]"]');
    if (!select) return 0;
    const selected = select.options[select.selectedIndex];
    if (!selected || selected.value === '') return 0;
    const realOptions = [...select.options].filter((option) => option.value !== '');
    return realOptions.indexOf(selected) + 1;
  };

  const buildFieldMap = (form) => {
    const formData = new FormData(form);
    const get = (name) => normalizeValue(formData.get(name));
    const fullName = get('contact[full-name]');
    const company = get('contact[company-name]');
    const email = get('contact[email]');
    const website = get('contact[website]');
    const productType = get('contact[product-type]');
    const quantity = get('contact[estimated-quantity]');
    const timeline = get('contact[target-timeline]');
    const techPacks = get('contact[tech-packs-samples]');
    const notes = get('contact[project-notes]');
    const confirmed = formData.has('contact[no-obligation-confirmed]');
    const pageUrl = window.location.href;
    const sectionId = form.dataset.sectionId || '';

    const customProperties = {
      full_name: fullName,
      company_name: company,
      website,
      product_type: productType,
      estimated_quantity: quantity,
      target_timeline: timeline,
      tech_packs_samples: techPacks,
      project_notes: notes,
      no_obligation_confirmed: confirmed,
      source_form: 'production-call-form',
      section_id: sectionId,
      page_url: pageUrl,
      submitted_at: new Date().toISOString(),
    };

    Object.keys(customProperties).forEach((key) => {
      const value = customProperties[key];
      if (value === '' || value === null || value === undefined) {
        delete customProperties[key];
      }
    });

    const { firstName, lastName } = splitName(fullName);

    return {
      email,
      company,
      firstName,
      lastName,
      quantityPosition: getQuantityPosition(form),
      customProperties,
      pageUrl,
      sectionId,
    };
  };

  const sendToBackend = async ({ backendUrl, fieldMap }) => {
    if (!backendUrl) return;

    const payload = {
      email: fieldMap.email,
      firstName: fieldMap.firstName,
      lastName: fieldMap.lastName,
      company: fieldMap.company,
      properties: fieldMap.customProperties,
    };

    const response = await fetch(backendUrl, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const body = await response.text();
    if (!response.ok) {
      throw new Error(`Klaviyo backend request failed (${response.status}): ${body}`);
    }

    console.info('Klaviyo backend response', body);
  };

  const SCHEDULER_LEAD_KEY = 'sk:productionCallLead';

  const stashLeadForScheduler = (fieldMap) => {
    if (!fieldMap) return;
    try {
      const name = [fieldMap.firstName, fieldMap.lastName].filter(Boolean).join(' ').trim();
      sessionStorage.setItem(
        SCHEDULER_LEAD_KEY,
        JSON.stringify({ name, email: fieldMap.email || '', quantityPosition: fieldMap.quantityPosition || 0 })
      );
    } catch (error) {
      console.warn('Unable to stash lead for scheduler', error);
    }
  };

  const readStashedLead = () => {
    try {
      const raw = sessionStorage.getItem(SCHEDULER_LEAD_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  };

  const loadCalendlyAssets = () => {
    if (!document.querySelector('link[data-calendly-widget-css]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://assets.calendly.com/assets/external/widget.css';
      link.setAttribute('data-calendly-widget-css', '');
      document.head.appendChild(link);
    }

    if (window.Calendly) return Promise.resolve();
    if (window._skCalendlyScriptPromise) return window._skCalendlyScriptPromise;

    window._skCalendlyScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Failed to load Calendly widget script'));
      document.head.appendChild(script);
    });

    return window._skCalendlyScriptPromise;
  };

  const isSchedulerEligible = (minPosition, lead) => {
    // 1 (or unset) means show the scheduler to everyone.
    if (!Number.isFinite(minPosition) || minPosition <= 1) return true;
    const position = Number(lead?.quantityPosition) || 0;
    // Cannot verify the position (e.g. page refreshed without a fresh submission).
    if (!position) return false;
    return position >= minPosition;
  };

  // Calendly posts a `calendly.page_height` message whenever its inner page
  // changes height (calendar → time → details). We resize the matching widget
  // container to that height so the card grows/shrinks with the content instead
  // of showing an internal scrollbar. Falls back to the CSS height if no message.
  const ensureCalendlyAutoResize = () => {
    if (window._skCalendlyAutoResize) return;
    window._skCalendlyAutoResize = true;

    window.addEventListener('message', (event) => {
      const data = event.data;
      if (!data || typeof data !== 'object' || data.event !== 'calendly.page_height') return;

      const height = data.payload && data.payload.height;
      if (!height) return;

      document.querySelectorAll('[data-calendly-target] iframe').forEach((iframe) => {
        if (iframe.contentWindow === event.source) {
          const wrap = iframe.closest('[data-calendly-target]');
          if (wrap) wrap.style.height = height;
        }
      });
    });
  };

  const initCalendlyScheduler = (scope = document) => {
    ensureCalendlyAutoResize();
    const containers = scope.querySelectorAll('[data-calendly-scheduler]');

    containers.forEach((container) => {
      const target = container.querySelector('[data-calendly-target]');
      const url = container.dataset.calendlyUrl?.trim();
      if (!target || !url || target.dataset.calendlyReady === 'true') return;

      const lead = readStashedLead();
      const minPosition = parseInt(container.dataset.calendlyMinPosition, 10);

      if (!isSchedulerEligible(minPosition, lead)) {
        container.hidden = true;
        sessionStorage.removeItem(SCHEDULER_LEAD_KEY);
        return;
      }

      target.dataset.calendlyReady = 'true';
      container.hidden = false;

      loadCalendlyAssets()
        .then(() => {
          if (!window.Calendly) return;

          const prefill = {};
          if (lead?.name) prefill.name = lead.name;
          if (lead?.email) prefill.email = lead.email;

          // Hide Calendly's own event-type header and GDPR banner so the widget
          // is compact enough to fit without an internal scrollbar.
          const embedUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'hide_event_type_details=1&hide_gdpr_banner=1';
          window.Calendly.initInlineWidget({ url: embedUrl, parentElement: target, prefill });
          sessionStorage.removeItem(SCHEDULER_LEAD_KEY);
        })
        .catch((error) => {
          target.dataset.calendlyReady = 'false';
          console.warn('Calendly scheduler init failed', error);
        });
    });
  };

  const initProductionCallForms = (scope = document) => {
    if (!window._skProductionCallGlobalClickDebug) {
      window._skProductionCallGlobalClickDebug = true;
      document.addEventListener(
        'click',
        async (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;
          const button = target.closest('button');
          const input = target.closest('input, select, textarea');
          if (button || input) {
            console.info('Document click capture', {
              tagName: target.tagName,
              buttonType: button?.type || null,
              buttonData: button?.dataset ? { ...button.dataset } : null,
              inputName: input?.name || null,
            });
          }

          const submitButton = target.closest('[data-step-submit]');
          if (!submitButton) return;

          const root = submitButton.closest('[data-production-form]');
          const sectionRoot = submitButton.closest('section[data-klaviyo-backend-url]');
          const form = submitButton.closest('form');
          const backendUrl = sectionRoot?.dataset.klaviyoBackendUrl?.trim();

          if (!root || !form || !backendUrl) {
            console.warn('Production form backend missing', {
              hasRoot: Boolean(root),
              hasForm: Boolean(form),
              hasBackendUrl: Boolean(backendUrl),
            });
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();

          if (root.dataset.klaviyoSubmitting === 'true') return;

          const invalidField = [...form.elements].find((field) =>
            typeof field.checkValidity === 'function' && !field.checkValidity()
          );
          if (invalidField) {
            const step = invalidField.closest('[data-step-content]');
            if (step && root.productionCallFormSteps) {
              root.productionCallFormSteps.goTo(Number(step.dataset.stepContent), false, true);
            }
            invalidField.reportValidity();
            return;
          }

          root.dataset.klaviyoSubmitting = 'true';

          if (submitButton instanceof HTMLButtonElement) {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-busy', 'true');
          }

          const fieldMap = buildFieldMap(form);

          try {
            await sendToBackend({ backendUrl, fieldMap });
            console.info('Klaviyo backend request completed');
          } catch (error) {
            console.warn('Klaviyo submission failed', error);
          } finally {
            if (submitButton instanceof HTMLButtonElement) {
              submitButton.disabled = false;
              submitButton.removeAttribute('aria-busy');
            }

            root.dataset.klaviyoSubmitting = 'false';
            stashLeadForScheduler(fieldMap);
            form.submit();
          }
        },
        true
      );
    }

    scope.querySelectorAll('[data-production-form]').forEach((root) => {
      if (!root.productionCallFormSteps) {
        new ProductionCallFormSteps(root);
      }

      if (root._skKlaviyoFormInit) return;
      root._skKlaviyoFormInit = true;

      const form = root.querySelector('form');
      const submitButton = root.querySelector('[data-step-submit]');
      const sectionRoot = root.closest('section[data-klaviyo-backend-url]');
      const backendUrl = sectionRoot?.dataset.klaviyoBackendUrl?.trim();

      console.info('Production form init', {
        hasForm: Boolean(form),
        hasBackendUrl: Boolean(backendUrl),
        hasSubmitButton: Boolean(submitButton),
        backendUrl,
      });

      if (!form || !backendUrl) return;

      form.addEventListener(
        'invalid',
        (event) => {
          const target = event.target;
          if (target && target.name) {
            console.warn('Production form invalid field', target.name, target.validationMessage);
          }
        },
        true
      );

      if (submitButton) {
        submitButton.addEventListener('click', () => {
          console.info('Production submit button clicked');
        });
      }

      root.addEventListener(
        'click',
        (event) => {
          const target = event.target;
          if (target instanceof Element) {
            const stepTrigger = target.closest('[data-step-trigger]');
            const stepNext = target.closest('[data-step-next]');
            const stepPrev = target.closest('[data-step-prev]');
            const stepSubmit = target.closest('[data-step-submit]');

            if (stepTrigger || stepNext || stepPrev || stepSubmit) {
              console.info('Production form click', {
                stepTrigger: Boolean(stepTrigger),
                stepNext: Boolean(stepNext),
                stepPrev: Boolean(stepPrev),
                stepSubmit: Boolean(stepSubmit),
              });
            }
          }
        },
        true
      );

      form.addEventListener('submit', (event) => {
        console.info('Production form submit triggered');
        event.preventDefault();
      });
    });
  };

  initProductionCallForms();
  initCalendlyScheduler();

  document.addEventListener('shopify:section:load', (event) => {
    initProductionCallForms(event.target);
    initCalendlyScheduler(event.target);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-call-hero"] && !Shopify.designMode) return;
  try {
    
  // Hero video: controls on desktop, hidden on mobile until the video is tapped.
  (function () {
    var videos = document.querySelectorAll('.sk-production-hero__media video');
    if (!videos.length) return;

    var desktop = window.matchMedia('(min-width: 901px)');

    function sync() {
      videos.forEach(function (video) {
        video.controls = desktop.matches;
      });
    }

    sync();

    if (desktop.addEventListener) {
      desktop.addEventListener('change', sync);
    } else if (desktop.addListener) {
      desktop.addListener(sync);
    }

    videos.forEach(function (video) {
      video.addEventListener('click', function () {
        if (!desktop.matches) {
          video.controls = true;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
